import { render } from "./orders.html?vue&type=template&id=60ffc7f7&external"
import script from "./orders.js?vue&type=script&lang=js&external"
export * from "./orders.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__